<div>
  <div *ngIf="imageUrl" class="img-template-list">
    <img
      class="img-thumb"
      [src]="imageUrl"
      [style.width.px]="widthPx"
      [style.height.px]="heightPx" />
    <button
      class="btn btn-sm btn-danger delete"
      (click)="onDeleteImage()"
      *ngIf="!showDeleteIcon">
      <i class="bx bx-trash"></i>
    </button>
  </div>
  <div
    *ngIf="!imageUrl && !headLess"
    class="no-image"
    [style.width.px]="widthPx"
    [style.height.px]="heightPx">
    <button class="btn btn-soft-primary" (click)="onOpenModal()">
      Upload Image
    </button>
  </div>
  <div
    *ngIf="!imageUrl && headLess"
    [style.width.px]="widthPx"
    [style.height.px]="heightPx"></div>
</div>

<ng-template #imageModal let-modal>
  <div class="card p-0 m-0 shadow-none">
    <div class="card-header p-0 bg-transparent">
      <div class="row align-items-center g-0">
        <div class="col">
          <ul
            ngbNav
            #outlet="ngbNav"
            [activeId]="active"
            (navChange)="navChange($event)"
            class="nav-tabs nav-tabs-custom nav-justified border-0">
            <li [ngbNavItem]="1">
              <a ngbNavLink class="">My Photos</a>
              <ng-template ngbNavContent>
                <app-user-media (emitter)="onSelect($event)"></app-user-media>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" *ngIf="isHarmonyCorp">
              <a ngbNavLink class="">Harmony Photos</a>
              <ng-template ngbNavContent>
                <app-user-media
                  (emitter)="onSelect($event)"
                  [loadCommunityImagesInd]="true"></app-user-media>
              </ng-template>
            </li>
            <li [ngbNavItem]="2" *ngIf="!isHarmonyCorp">
              <a ngbNavLink class="">Stock Photos</a>
              <ng-template ngbNavContent>
                <app-unsplash (emitter)="onSelect($event)"></app-unsplash>
              </ng-template>
            </li>
            <li [ngbNavItem]="3" [disabled]="disabled">
              <a ngbNavLink class=""> Crop </a>
              <ng-template ngbNavContent>
                <ng-container *ngIf="file">
                  <app-cropper
                    [size]="{
                      width: widthPx,
                      height: heightPx,
                      maintainAspectRatio: true
                    }"
                    [getRawBase64]="true"
                    [file]="file"
                    (emitter)="onCrop($event)"
                    (keep)="onKeep()"></app-cropper>
                </ng-container>
              </ng-template>
            </li>
          </ul>
        </div>
        <div class="col-auto">
          <button (click)="modal.close()" type="button" class="btn text-black">
            <i class="mdi mdi-close-thick align-middle"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div [ngbNavOutlet]="outlet"></div>
    </div>
  </div>
</ng-template>
